module.exports = __webpack_public_path__ + "img/contest-2.d98e6400.png";